import { render, staticRenderFns } from "./UserLevelConfigModal.vue?vue&type=template&id=08d72eb8&scoped=true&"
import script from "./UserLevelConfigModal.vue?vue&type=script&lang=js&"
export * from "./UserLevelConfigModal.vue?vue&type=script&lang=js&"
import style0 from "./UserLevelConfigModal.vue?vue&type=style&index=0&id=08d72eb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d72eb8",
  null
  
)

export default component.exports